/* eslint-disable max-len */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import PropTypes from "prop-types";
import id from "@irati/utils/id";
import BaseSvgIcon from "./Base";
var Lightbulb = function (props) {
    var titleId = id("title", props);
    var title = props.title, rest = __rest(props, ["title"]);
    return (React.createElement(BaseSvgIcon, __assign({}, rest, { "aria-labelledby": titleId }),
        React.createElement("title", { id: titleId }, title),
        React.createElement("g", { fill: "none", fillRule: "evenodd" },
            React.createElement("rect", { height: "18", rx: "1", width: "18" }),
            React.createElement("g", { stroke: "#000" },
                React.createElement("path", { d: "m7 12.4648712c-1.19560274-.6916188-2-1.9843065-2-3.4648712 0-2.209139 1.790861-4 4-4s4 1.790861 4 4c0 1.4805647-.8043973 2.7732524-2 3.4648712v1.5351288c0 1.1045695-.8954305 2-2 2s-2-.8954305-2-2z" }),
                React.createElement("path", { d: "m9 1v2", strokeLinecap: "round" }),
                React.createElement("path", { d: "m17 9h-2", strokeLinecap: "round" }),
                React.createElement("path", { d: "m3 9h-2", strokeLinecap: "round" }),
                React.createElement("path", { d: "m15 3-1.5 1.5", strokeLinecap: "round" }),
                React.createElement("path", { d: "m4.5 3-1.5 1.5", strokeLinecap: "round", transform: "matrix(-1 0 0 1 7.5 0)" })))));
};
Lightbulb.propTypes = {
    id: PropTypes.string,
    title: PropTypes.string
};
Lightbulb.defaultProps = {
    id: "lightbulb-icon",
    title: "Lightbulb"
};
export default Lightbulb;
